<script setup lang="ts">
import { ref } from 'vue'
import TheIcon from '@/components/atoms/TheIcon/TheIcon.vue'
import clickOutside from 'click-outside-vue3'

defineProps<{
    icon: {
        name: string
    }
    position: {
        top?: boolean
        bottom?: boolean
    }
    content: string
}>()
const vClickOutside = clickOutside.directive
const isOpen = ref(false)

const onClickOutside = () => {
    isOpen.value = false
}
</script>
<template>
    <div
        class="pop-over"
        :class="position.bottom ? 'pop-over--bottom' : 'pop-over--top'"
    >
        <span
            class="pop-over__icon"
            @click="isOpen = !isOpen"
            ><TheIcon :name="icon.name"
        /></span>
        <span
            v-click-outside="onClickOutside"
            class="pop-over__container"
            v-if="isOpen"
        >
            <div v-html="content"></div>
        </span>
    </div>
</template>
<style lang="scss" scoped>
.pop-over {
    margin-left: auto;

    &__icon {
        display: block;
        line-height: 0;
        cursor: pointer;
        font-size: rem(32);
        color: $dn-blue;
    }

    &__container {
        font-size: 1.5rem;
        font-weight: $font-weight-normal;
        display: block;
        position: absolute;
        background-color: $dn-white;
        right: 0;
        width: 100%;
        max-width: 450px;
        border: rem(1) solid #e2e2e2;
        z-index: 14;
        padding: rem(18);
        box-shadow: 0 0 rem(60) rgba(0, 0, 0, 0.12);

        .pop-over--top & {
            border-radius: rem(8) rem(8) rem(2) rem(8);
            bottom: rem(46);

            @include media-breakpoint-up(md) {
                border-radius: rem(8);
            }
        }
        .pop-over--bottom & {
            border-radius: rem(8) rem(2) rem(8) rem(8);
            top: rem(46);

            @include media-breakpoint-up(md) {
                border-radius: rem(8);
            }
        }

        @include media-breakpoint-up(md) {
            right: rem(-26);
        }

        &::after {
            content: '';
            position: absolute;
            right: rem(5);
            border-top: rem(1) solid #e2e2e2;
            border-left: rem(1) solid #e2e2e2;
            width: rem(21);
            height: rem(21);
            background-color: white;

            @include media-breakpoint-up(md) {
                right: rem(30.5);
            }

            .pop-over--top & {
                bottom: rem(-11.2);
                transform: rotate(225deg);
            }

            .pop-over--bottom & {
                top: rem(-11.12);
                transform: rotate(45deg);
            }
        }
    }
}
</style>
